import { Link } from 'gatsby'
import React, { FC } from 'react'
import { motion } from 'framer-motion'
import RightArrowIcon from './icons/right-arrow-icon'

interface Props {
  text?: string
  url?: string
  isShowing?: boolean
}

const CTABanner: FC<Props> = ({
  text = 'Request a Live Demo',
  url = '/request-demo',
  isShowing = true,
}) => {
  return (
    <motion.div
      className='sticky bottom-0'
      initial={{ opacity: 0, y: 80 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.15, ease: [0.17, 0.47, 0.43, 0.97] }}
    >
      <Link
        className={`md:hidden ${
          !isShowing ? 'hidden' : ''
        } flex items-center justify-center w-full p-2 text-center bg-gradient-to-r from-blue to-blue-cobalt font-bold text-white`}
        to={url}
      >
        <span className='mr-2'>{text}</span>
        <RightArrowIcon />
      </Link>
    </motion.div>
  )
}

export default CTABanner
